import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "hooks";
import { useDealIdSelector } from "store";

interface IProps {
  /** Current section label shown after the back chevron. */
  current: string;
  /** Page title rendered below the crumb, inside the sticky header. */
  title?: string;
}

export const InsightsBreadcrumb: React.FC<IProps> = ({ current, title }) => {
  const dealId = useDealIdSelector();
  const navigate = useNavigate();

  const goInsights = () => dealId && navigate({ route: "dealInsights", params: { deal_id: dealId } });

  return (
    <Stack gap="8px">
      <Stack direction="row" alignItems="center" gap="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="4px"
          onClick={goInsights}
          sx={{ cursor: "pointer", color: "#5d7782", "&:hover": { color: "#071F35" } }}
        >
          <ArrowBackIcon sx={{ fontSize: "16px" }} />
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Back</Typography>
        </Stack>
        <Typography sx={{ fontSize: "14px", color: "#94A3B8" }}>›</Typography>
        <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#071F35" }}>{current}</Typography>
      </Stack>
      {title && <Typography sx={{ fontWeight: 600, fontSize: "20px", color: "#071F35" }}>{title}</Typography>}
    </Stack>
  );
};
